import script from "./grid-col-widget.vue?vue&type=script&setup=true&lang=js"
export * from "./grid-col-widget.vue?vue&type=script&setup=true&lang=js"

import "./grid-col-widget.vue?vue&type=style&index=0&id=1e5ac536&scoped=true&lang=css"

import exportComponent from "D:\\code\\form_designer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e5ac536"]])

export default __exports__